<template>
  <div class="min-h-screen bg-gray-50 text-gray-900 font-sans flex flex-col">
    <GeneratorView class="flex-grow" />
    <footer class="py-6 text-center text-sm text-slate-500">
      2026 - Crud Exercises Generator - <a href="https://www.gabriarcu.it" target="_blank"
        class="text-blue-600 hover:text-blue-800 transition-colors font-medium">Gabriarcu</a>
    </footer>
  </div>
</template>

<script>
import GeneratorView from './views/Generator.vue'

export default {
  name: 'App',
  components: {
    GeneratorView
  }
}
</script>
